import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSection } from './PricingSection';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 bg-charcoal border-t border-white/10" data-id="element-126">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="mb-12" data-id="element-128">
          <CountdownTimer data-id="element-129" />
        </div>

        <PricingSection data-id="element-130" />

        <div className="mt-8 flex flex-wrap justify-center items-center gap-6 text-sm font-medium text-gray-300" data-id="element-131">
          <div className="flex items-center gap-2" data-id="element-132">
            <Lock className="w-5 h-5 text-gold" data-id="element-133" />
            <span data-id="element-134">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-135">
            <Zap className="w-5 h-5 text-gold" data-id="element-136" />
            <span data-id="element-137">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-138">
            <Shield className="w-5 h-5 text-gold" data-id="element-139" />
            <span data-id="element-140">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-141">
            <CreditCard className="w-5 h-5 text-gold" data-id="element-142" />
            <span data-id="element-143">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}